import { useEffect } from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import AdminLayout from "../../../AdminLayout";
import EmptyContent from "../../../Components/Empty-content/EmptyContent";
import ItemsLoader from "../../../Components/Loader/basic loader/ItemsLoader";
import TitleBar from "../../../Components/TitleBar";
import { useLoaderStore } from "../../../Store/Loader/LoaderStore";
import { useAgeGroupReportStore } from "../../../Store/ReportsStore/AgeGroupReportStore";
import Heading from "./components/Heading";
import Table from "./components/Table";

function AgeGroupReports() {
  const { onReload, getBranches, getSubjects, ageGroupsList, isLoading } =
    useAgeGroupReportStore();
  const { setLoader } = useLoaderStore();

  const pageLoad = useCallback(async () => {
    setLoader(true);
    await Promise.all([onReload(), getBranches(), getSubjects()]);
    setLoader(false);
  }, []);

  useEffect(() => {
    pageLoad();
  }, []);

  const { t } = useTranslation();

  return (
    <AdminLayout>
      <TitleBar title={t("Guruhlarning yosh turi bo'yicha hisoboti")} />
      <div className="container">
        <Heading />
        {isLoading ? (
          <ItemsLoader size={70} />
        ) : ageGroupsList?.length > 0 ? (
          <Table />
        ) : (
          <EmptyContent />
        )}
      </div>
    </AdminLayout>
  );
}

export default AgeGroupReports;
